import { useState, useEffect } from "react";
import axios from "axios";
import { shopFromSettings } from "@/lib/quoteDoc";
import { BACKEND_URL } from "@/lib/backendUrl";

const API = `${BACKEND_URL}/api`;

// Shop block (name, address, phone, currency, country code…) for pages without full settings
export function useShopMeta() {
  const [shop, setShop] = useState(() => shopFromSettings(null));
  useEffect(() => {
    axios.get(`${API}/settings`).then(({ data }) => setShop(shopFromSettings(data))).catch(() => {});
  }, []);
  return shop;
}

export const useCurrencySymbol = () => useShopMeta().sym;
